import React from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from "./FirebaseAuthContext";

const PublicRoute = ({ children }) => {
    const auth = useAuth();
    return auth.user === null ? children : <Navigate to="/dashboard" />;
}

export default PublicRoute;
